var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{staticClass:"q-summit-sidebar-drawer",class:{ 'q-summit-sidebar-drawer__opened': _vm.doShowDrawer},attrs:{"light":"","right":"","width":_vm.doShowDrawer ? '100%' : 0,"temporary":""},model:{value:(_vm.doShowDrawer),callback:function ($$v) {_vm.doShowDrawer=$$v},expression:"doShowDrawer"}},[_c('QSummitSidebar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }